import {
  initFirebase,
  readFirebaseConfigFromEnv,
  FirebaseAuthRepository,
  FirebaseUserRepository,
  type FirebaseServices,
} from '@nx/infrastructure';
import type { AuthRepository, UserRepository } from '@nx/domain';

const services: FirebaseServices = initFirebase(
  readFirebaseConfigFromEnv(import.meta.env as unknown as Record<string, string | undefined>),
);

export const { auth, db, storage, functions } = services;

export const authRepository: AuthRepository = new FirebaseAuthRepository({
  auth: services.auth,
  db: services.db,
});

export const userRepository: UserRepository = new FirebaseUserRepository(services.db);
